import Util from "../../Util/Util";
import config from "../../config";

export default class KeywordsAPI {
    getAll() {
        const jwt_token = localStorage.getItem("jwt_token");
        return Util.apiCall(config.server, `/v1/user/keywords?jwt_token=${jwt_token}`, "GET");
    }
}